import { extractArrayFromQuery } from '../../../utils/query';

export default function(param) {
  return {
    param: extractArrayFromQuery,
    query: function (values) {
      if (values.length > 0) {
        return {
          $or: values.map(function(value) {
            return {
              [param]: {
                1: 'Strongly Agree',
                2: 'Agree',
                3: 'Neutral',
                4: 'Disagree',
                5: {
                  $null: true
                }
              }[value]
            }
          })
        }
      }
    }
  }
}
